import { AppAnimate, AppCard, AppGridContainer, AppInfoView } from "@crema";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Params, useParams } from "react-router-dom";
import {  getCentreDetail } from "redux/actions/support";
import { AppState } from "redux/store";
import CentreCreate from "./centreCreate";
import CentreHeader from "./centreHeader";

const CentreIndex: React.FC<{}> = () => { 
  const dispatch = useDispatch();
  const { id } = useParams<Readonly<Params>>();
  console.log(id);
  const { currentCentre } = useSelector<AppState, AppState["support"]>(
    ({ support }) => support
  );
  useEffect(() => {
    dispatch( getCentreDetail(+id! as number));
  }, [dispatch, id]);

  return (
    <>
      {currentCentre ? (
        <AppAnimate animation="transition.slideUpIn" delay={200}>
          <AppCard>
          <CentreHeader centre={currentCentre} />
          <div>Centre ID: {id}</div>
             <AppGridContainer>
              <CentreCreate Centre={currentCentre} />
            </AppGridContainer>
          </AppCard>
        </AppAnimate>
      ) : null}
      <AppInfoView />
    </>
  );
};

export default CentreIndex;
